import { ProviderModel } from '../../../data/entities';
import style from '../styles/Provider.module.scss';

interface ProviderItemProps {
  provider: ProviderModel;
  isSelected: boolean;
  onClick: () => void;
}

const ProviderItem = ({ provider, isSelected, onClick }: ProviderItemProps) => {
  const apiBaseUrl = process.env.REACT_APP_API_URL;
  return (
    <div
      onClick={onClick}
      className={`${style.provider} ${isSelected ? style.selected : ''}`}
    >
      <img
        src={`${apiBaseUrl}provider/${provider.id}/profilepicture`}
        alt={provider.name}
        className={style.providerImage}
      />
      <span>{provider.name}</span>
    </div>
  );
};

export default ProviderItem;
